import React, { useState, useEffect } from 'react';
import styles from './MenuPanel.module.scss'
import { CalciteShellPanel, CalciteActionBar, CalciteAction } from '@esri/calcite-components-react';
import DefineMyCommunity from '.././DefineMyCommunity/DefineMyCommunity';
import PrintComponent from '.././PrintComponent/PrintComponent';
import LayersAndLegend from '../LayersAndLegend/LayersAndLegend';
import RelatedLinks from '../RelatedLinks/RelatedLinks';
import BrownfieldFilter from '../BrownfieldFilter/BrownfieldFilter';
import ReleaseFilters from '../ReleaseFilters/ReleaseFilters';
import CleanupsFilter from '../CleanupsFilter/CleanupsFilter';
import SeaLevelRise from '../SeaLevelRise/SeaLevelRise';
import { default as filter_b_gray } from '../../assets/filter_b_gray.svg';
import { default as filter_r } from '../../assets/filter_r.svg';
import { default as filter_c_gray } from '../../assets/filter_c_gray.svg';

const MenuPanel = (props) => {
  const [useWidth, setUseWidth] = useState<any>('m');
  const [lastActiveTool, setLastActiveTool] = useState<string>('Define My Community')
  const [toolThatWasClicked, setThatWasClicked] = useState<string>('')
  const [activeTool, setActiveTool] = useState<string>('Define My Community');
  const [loadedTools, setLoadedTools] = useState<Array<string>>(['Define My Community', props.extensionData?.type === 'site' ? 'Cleanups Filter' : '']);
  // called whenever one of the tools from the bar is clicked
  const handleTool = (tool) => {
    if (!loadedTools.includes(tool)) setLoadedTools([...loadedTools, tool]);
    setLastActiveTool(activeTool);
    setThatWasClicked(tool)
    setActiveTool(tool)
  }

  useEffect(() => {
    if (['Brownfield Filter', 'Cleanups Filter', 'Release Filter'].find(filter => filter === toolThatWasClicked)) {
      setUseWidth('l')
    } else { setUseWidth('m') }
    if (toolThatWasClicked === lastActiveTool) {
      setActiveTool('');
    }
    else { setActiveTool(activeTool); }
  }, [lastActiveTool, toolThatWasClicked, activeTool, loadedTools])

  return (
    <CalciteShellPanel className={styles.clickableBackground} width-scale={useWidth} slot='panel-start' display-mode='float' detached>
      <CalciteActionBar slot='action-bar' scale={'m'}>
        <CalciteAction text='Define Your Community' icon='information' scale='m' onClick={() => { handleTool('Define My Community') }}></CalciteAction>
        <CalciteAction text='Layers' icon='layers' scale='m' onClick={() => { handleTool('Layers/Legend') }}></CalciteAction>
        <CalciteAction text='Print' icon='print' scale='m' onClick={() => { handleTool('Print') }}></CalciteAction>
        <CalciteAction text='Links to related maps' icon='link' scale='m' onClick={() => { handleTool('Links') }}></CalciteAction>
        <CalciteAction text='Brownfield Filters' scale='m' onClick={() => { handleTool('Brownfield Filter') }}>
          <object type="image/svg+xml" data={filter_b_gray} className={styles.filterIcons}>Brownfield Filters</object>
        </CalciteAction>
        <CalciteAction text='Cleanup Filters' scale='m' onClick={() => { handleTool('Cleanups Filter'); }}>
          <object type="image/svg+xml" data={filter_c_gray} className={styles.filterIcons}>Cleanup Filters</object>
        </CalciteAction>
        <CalciteAction text='Release Filters' scale='m' onClick={() => { handleTool('Release Filter'); }}>
          <object type="image/svg+xml" data={filter_r} className={styles.filterIcons}>Releaase Filters</object>
        </CalciteAction>
        <CalciteAction text='Sea Level Rise Scenarios' icon='embark' scale='m' onClick={() => { handleTool('Sea Level Rise') }}></CalciteAction>
      </CalciteActionBar>
      {loadedTools.includes('Define My Community') && <div className={styles.componentDivs} hidden={activeTool !== 'Define My Community'}>
        <DefineMyCommunity webmap={props.webmap} view={props.view} sourcesForSearching={props.sourcesForSearching} />
      </div>}

      {loadedTools.includes('Layers/Legend') && <div className={styles.componentDivs} hidden={activeTool !== 'Layers/Legend'}>
        <LayersAndLegend view={props.view} webmap={props.webmap} />
      </div>}

      {loadedTools.includes('Links') && <div className={styles.componentDivs} hidden={activeTool !== 'Links'}>
        <RelatedLinks />
      </div>}

      {loadedTools.includes('Print') && <div className={styles.componentDivs} hidden={activeTool !== 'Print'}>
        <PrintComponent view={props.view} />
      </div>}

      {loadedTools.includes('Cleanups Filter') && <div className={styles.componentDivs} hidden={activeTool !== 'Cleanups Filter'}>
        <CleanupsFilter webmap={props.webmap} view={props.view} 
        siteType={props.extensionData ? props.extensionData.siteType ? props.extensionData.siteType : null : null} 
        isBrownfieldRoute = {props.extensionData ? props.extensionData.type === 'bfJurisdiction' ? true : false : false}/>
        {/* <CleanupsFilter webmap={props.webmap} view={props.view} siteType={props.extensionData && props.extensionData.siteType ? props.extensionData.siteType : null} isBrownfieldRoute = {props.extensionData.type === 'bfJurisdiction' ? true : false}/> */}
      </div>}

      {loadedTools.includes('Brownfield Filter') && <div className={styles.componentDivs} hidden={activeTool !== 'Brownfield Filter'}>
        <BrownfieldFilter webmap={props.webmap} view={props.view} />
      </div>}

      {loadedTools.includes('Release Filter') && <div className={styles.componentDivs} hidden={activeTool !== 'Release Filter'}>
        <ReleaseFilters webmap={props.webmap} view={props.view} customRouteUsed={props.extensionData && props.extensionData.type === 'ustSpecific' ? true : null} />
      </div>}

      {loadedTools.includes('Sea Level Rise') && <div className={styles.componentDivs} hidden={activeTool !== 'Sea Level Rise'}>
        <SeaLevelRise toggleSeaRiseLayers={props.toggleSeaRiseLayers} activeSlrValue={props.activeSlrValue} />
      </div>}

    </CalciteShellPanel>
  )
}

export default MenuPanel;